import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Instagram, Youtube, Twitter, Mail, MapPin, Phone, ArrowUp } from 'lucide-react';
import { LOGO_URL, navLinks } from '../mock';

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <footer id="contact" className="relative bg-[#0f0d0b] text-[#c9bfa9] pt-24 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="md:col-span-5"
        >
          <div className="flex items-center gap-4">
            <img src={LOGO_URL} alt="WBS" className="h-16 w-auto" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
            <div className="border-l border-[#c8942a]/40 pl-4">
              <div className="font-serif-display text-[10px] tracking-[0.4em] uppercase text-[#f0c95a] font-black">Cambridge Pathway · Since 2010</div>
              <div className="font-serif-display text-xl font-black text-white mt-1">Whiteplains British School</div>
              <div className="font-cormorant italic text-sm text-[#c9bfa9]">Bonitas et Disciplina</div>
            </div>
          </div>
          <p className="mt-6 max-w-md text-sm leading-[1.75] font-light">
            A Cambridge Pathway school delivering the English National Curriculum from Pre-Nursery,
            via Cambridge Checkpoint, through to IGCSE and A-Level. We prepare confident, curious and
            principled scholars for the world&apos;s finest universities.
          </p>
          <div className="flex gap-2 mt-8">
            {[Facebook, Instagram, Youtube, Twitter].map((Icon, idx) => (
              <a key={idx} href="#" className="w-10 h-10 border border-white/15 hover:border-[#c8942a] hover:bg-[#c8942a] transition-colors grid place-items-center">
                <Icon size={15} />
              </a>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="md:col-span-3"
        >
          <h4 className="font-sans-pro text-white text-[11px] uppercase tracking-[0.35em] mb-6">Navigate</h4>
          <ul className="space-y-3 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="hover:text-[#f0c95a] transition-colors">{l.label}</a>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="md:col-span-4"
        >
          <h4 className="font-sans-pro text-white text-[11px] uppercase tracking-[0.35em] mb-6">Contact</h4>
          <ul className="space-y-4 text-sm font-light">
            <li className="flex gap-3"><MapPin size={16} className="mt-0.5 text-[#c8942a] shrink-0" /> Whiteplains British School · Plot 528, Cadastral Zone B4, opposite Ukrainian Embassy, Abuja, Nigeria</li>
            <li className="flex gap-3"><Phone size={16} className="mt-0.5 text-[#c8942a] shrink-0" /> 0803 345 3457</li>
            <li className="flex gap-3"><Mail size={16} className="mt-0.5 text-[#c8942a] shrink-0" /> admissions@whiteplainsbritishschool.com</li>
          </ul>
          <button onClick={scrollTop} className="mt-8 inline-flex items-center gap-2 font-sans-pro text-[11px] uppercase tracking-[0.28em] text-[#f0c95a] hover:text-white transition-colors">
            <ArrowUp size={14} /> Back to top
          </button>
        </motion.div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#a89b83]">
        <p>&copy; {new Date().getFullYear()} Whiteplains British School. All rights reserved.</p>
        <p className="flex items-center gap-2">
          Powered by <span className="text-[#f0c95a] font-serif-display font-black tracking-widest">WHITEPLAINS BRITISH SCHOOL</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
